import { useEffect } from 'react'

import { createPortal } from 'react-dom'
import { Link } from 'react-router-dom'

const BiometricNoticeModal = ({ onClose }: { onClose: () => void }) => {

useEffect(() => {
  document.body.classList.add('pf-modal-open')

  return () => {
    document.body.classList.remove('pf-modal-open')
  }
}, [])

  return createPortal(
    <div id="modal-example" className="pf-modal">
      <div className="pf-modal__dialog">
        <div className="pf-modal__content">
          <div className="pf-modal__body">
            <div className="pf-page__logo">
              <div className="pf-page__logo-content">
                <img
                  src='/logo.png'
                  alt='AllFans'
                  className='pf-page__logo-img'
                />
              </div>
            </div>
            <h2 className="pf-page__title">
              Biometric Information Processing Notice and Consent
            </h2>
            <div className="pf-page__descr"></div>
          <div className="pf-main-list">
            <p>Last Updated: 2025/06/21</p>
            <p>While Innodev Solutions Inc. (“Innodev”) and its affiliates do not process technical or algorithmically-generated 
              data regarding your physical, physiological, or behavioral characteristics that allow your identification, 
              including hand or face geometry, retinal or iris scans, fingerprints, voiceprints, or other biometric identifiers 
              or biometric information about you (collectively, “Biometric Data”), Biometric Data is collected from Content Data 
              that you upload and is processed and stored, in each case by our service provider, KYC AVC UK LTD (“KYC AVC UK”), 
              for verifying your age and identity in posted Content Data. KYC AVC UK will store and process your Biometric Data 
              for as long as determined in its agreement with Innodev, and in accordance with Innodev’s Privacy Policy, which 
              period will be no longer than the earliest of the date (1) promptly after Innodev ceases to have a relationship 
              with KYC AVC UK, (2) when the Biometric Data is no longer needed for the above purposes, or (3) six months after 
              your last interaction with Innodev. More information on KYC AVC UK’s biometric retention practices is available 
              at <Link to="https://verifymycontent.co.uk/privacy" className='terms-link'>https://verifymycontent.co.uk/privacy</Link> and <Link to="https://verifymyage.co.uk/privacy" className='terms-link'>https://verifymyage.co.uk/privacy</Link>, and any questions or requests 
              regarding the processing of your Biometric Data should be directed to info@verifymyconent.com and support@verifymyage.co.uk.
            </p>  
          </div>
          </div>
        </div>
          <div className="pf-modal__footer">
            <div className="pf-page__social">
              <button
                type="button"
                onClick={onClose}
                className="btn btn-default"
                style={{
                  width: '100%',
                  maxWidth: '220px'
                }}
              >
                Close
              </button>
            </div>
          </div>
      </div>
    </div>, document.body
  )
}

export default BiometricNoticeModal
